"use client";

import { useMemo } from "react";
import { type Target } from "@/generated/fastapi";
import {
  getTargetDisplayDescription,
  getTargetDisplayLabel,
} from "../utils/targetDisplay";

export default function useTargetItems(targets?: Target[] | null) {
  return useMemo(
    () =>
      (targets ?? []).map((target) => ({
        label: getTargetDisplayLabel(target),
        value: target.id,
        description: getTargetDisplayDescription(target),
      })),
    [targets],
  );
}
